import {Breadcrumb, Dropdown} from 'react-bootstrap'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useEffect, useState} from 'react'
import {TTabsOneUser} from './oneUserTypes'
import {OverviewTab} from './components/OverviewTab'
import {SettingsTab} from './components/SettingsTab'
import {UserChannelConfigTab} from './components/UserChannelConfigTab'
import {useNavigate, useParams} from 'react-router-dom'
import {useLazyQuery} from '@apollo/client'
import {toast} from 'react-toastify'
import {GET_ONE_MEMBER_USER} from '../../gql/queries/usersQuery'
import {IResAllUsers} from '../../types/users'
import {parseId, isAdministrator} from '../../helpers'
import {InfoBalance} from './components/InfoBalance'
import {DeductionsTab} from './components/DeductionsTab'
import {UserPermissionsTab} from './components/UserPermissionsTab'
import {TABS_ONE_USER} from '../../helpers/consts'
import {prependBackendUrl} from '../../gql/client'
import {useGetUser} from '../../store/userStore'
import {UserDifyConfigTab} from './components/UserDifyConfigTab'

export const OneUserPage = () => {
  const navigate = useNavigate()
  const [gqlGetUser, {data, error, refetch}] = useLazyQuery<IResAllUsers>(
    GET_ONE_MEMBER_USER,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const { id } = useParams()

  const [flagBalance] = useState(0)

  useEffect(() => {
    if (Number(id)) {
      gqlGetUser({
        variables: {
          id,
        },
      })
    }
  }, [gqlGetUser, id])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  const [tabs, setTabs] = useState<TTabsOneUser>('Overview')

  const currentUserId = useGetUser((s) => s.user?.user?.id)
  const userGroups = useGetUser((s) => s.user?.groups)?.map((g: any) => g.name || g) || []
  const permissions = useGetUser((s) => s.user?.permissions) || []
  const isAdmin = userGroups.includes('Administrador') || userGroups.includes('SuperAdministrador')
  const isSupervisor = userGroups.includes('Supervisor')
  const canManagePermissions = isAdmin || isAdministrator(permissions) || permissions.includes('manage_permissions')

  const node = data?.allUsers.edges[0].node

  const isViewingOwnProfile = currentUserId && node && parseId(currentUserId) === parseId(node.id)
  const isSupervisorOfTarget = isSupervisor && node?.groupAssignmentSet?.edges?.some(
    (edge) => (edge.node?.supervisors?.edges || []).some((s) => parseId(s.node.id) === parseId(currentUserId || ''))
  )
  const canAccessChannels = isAdmin || isViewingOwnProfile && isSupervisor || isSupervisorOfTarget

  const visibleTabs = TABS_ONE_USER.filter(t =>
    (t !== 'Channels' || canAccessChannels) &&
    (t !== 'Permissions' || canManagePermissions)
  )

  // if (loading || !data) {
  //   return <LoadingOneUserPage />
  // }

  if (data?.allUsers.edges.length === 0) {
    return <div>Not found</div>
  }

  // Debug: verificar si el avatar está cargando
  console.log('[OneUserPage] User avatar:', node?.avatar)
  console.log('[OneUserPage] Avatar URL:', node?.avatar ? prependBackendUrl(node.avatar) : 'no avatar')

  return (
    <div>
      <header className='header mb-3'>
        <Breadcrumb>
          <Breadcrumb.Item onClick={(e) => navigate('/users')}>Users</Breadcrumb.Item>
          <Breadcrumb.Item active> View users </Breadcrumb.Item>
        </Breadcrumb>
      </header>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div
                className='position-relative'
                style={{
                  width: '160px',
                  height: '160px',
                }}
              >
                <img
                  src={node?.avatar ? prependBackendUrl(node.avatar) : toAbsoluteUrl('/media/avatars/blank.png')}
                  alt={node?.firstName}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '0.95rem',
                  }}
                />
                <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div>
              </div>
            </div>

            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <a href='/#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                      {node?.firstName} {node?.lastName}
                    </a>
                    <a href='/#'>
                      <KTIcon iconName='verify' className='fs-1 text-primary' />
                    </a>
                  </div>
                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                    <a
                      href='/#'
                      className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                    >
                      {node?.primaryGroup && (
                        <>
                          <br />
                          <KTIcon iconName='profile-circle' className='fs-4 me-1' />
                          <span className='fw-bold'>Role: </span>
                          {node.primaryGroup.name}
                        </>
                      )}
                    </a>
                    {/* <a
                      href='/#'
                      className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                    >
                      <KTIcon iconName='geolocation' className='fs-4 me-1' />
                      SF, Bay Area
                    </a> */}
                    <a
                      href='/#'
                      className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                    >
                      <KTIcon iconName='sms' className='fs-4 me-1' />
                      {node?.email || 'N/R'}
                    </a>
                  </div>
                </div>

                <div className='d-flex my-4'>
                  {/*<button className='btn btn-sm btn-light me-2' id='kt_user_follow_button'>
                    <KTIcon iconName='check' className='fs-3 d-none' />

                    <span className='indicator-label'>Follow</span>
                    <span className='indicator-progress'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </button>
                  <button className='btn btn-sm btn-primary me-3'>Hire Me</button>*/}
                  <div className='me-0'>
                    <Dropdown>
                      <Dropdown.Toggle size='sm' variant='success' id='dropdown-basic'>
                        <i className='bi bi-three-dots fs-3'></i>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setTabs('Edit user')}>
                          Edit Profile
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setTabs('Deductions')}>
                          Deductions
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1 pe-8'>
                  <div className='d-flex flex-wrap'>
                    {node && <InfoBalance id={`${parseId(node.id)}`} flagBalance={flagBalance} />}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              {visibleTabs.map((tb) => (
                <li className='nav-item' key={tb}>
                  <button
                    className={`nav-link text-active-primary me-6 ${tb === tabs ? 'active' : ''}`}
                    onClick={() => setTabs(tb)}
                  >
                    {tb}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {node && tabs === 'Overview' && (
        <OverviewTab setTabs={setTabs} node={node} refetch={refetch} />
      )}
      {node && tabs === 'Edit user' && (
        <SettingsTab setTabs={setTabs} node={node} refetch={refetch} />
      )}
      {node && tabs === 'Channels' && canAccessChannels && <UserChannelConfigTab node={node} />}
      {node && tabs === 'Deductions' && <DeductionsTab />}
      {node && tabs === 'Permissions' && canManagePermissions && (
        <UserPermissionsTab userId={parseId(node.id)} userName={`${node.firstName} ${node.lastName}`} />
      )}
      {node && tabs === 'Dify' && isAdmin && <UserDifyConfigTab userId={Number(parseId(node.id))} orgDifyEnabled={true} />}
      {/* {tabs === 'Transactions' && <StatementsTab refetchBalance={refetchBalance} />} */}
    </div>
  )
}
